import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { PrivacyNoticeService } from '../services/privacy-notice.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-privacy-notice',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, CardModule, CheckboxModule, ToastModule],
  providers: [MessageService],
  templateUrl: './privacy-notice.component.html',
  styleUrl: './privacy-notice.component.scss',
})
export class PrivacyNoticeComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);
  private readonly privacyNoticeService = inject(PrivacyNoticeService);
  private readonly authService = inject(AuthService);

  readonly accepted = signal(false);
  readonly isSubmitting = signal(false);
  readonly isPublicView = computed(() => this.route.snapshot.data['publicView'] === true);
  readonly returnUrl = computed(() => this.route.snapshot.queryParamMap.get('returnUrl') || '/axa/professionals-registration-progress');

  ngOnInit(): void {
    if (this.isPublicView()) {
      return;
    }

    this.privacyNoticeService.getStatus().subscribe({
      next: status => {
        if (status.acknowledged) {
          this.router.navigateByUrl(this.returnUrl());
        }
      },
      error: () => {
        // Keep the page visible so the user can retry once the backend endpoint is available.
      },
    });
  }

  onConfirm(): void {
    if (this.isPublicView() || !this.accepted() || this.isSubmitting()) {
      return;
    }

    this.isSubmitting.set(true);
    this.privacyNoticeService.acknowledge().subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.router.navigateByUrl(this.returnUrl());
      },
      error: () => {
        this.isSubmitting.set(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Non è stato possibile registrare la presa visione dell\'informativa privacy. Riprova.',
          life: 5000,
        });
      },
    });
  }

  goHome(): void {
    if (this.authService.isAuthenticated()) {
      this.authService.redirectAfterAuthentication();
    } else {
      this.router.navigate(['/login']);
    }
  }
}